import React from "react";
import {
  TextInput,
  Filter,
  RefreshButton,
  CreateButton,
  WithPermission
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";
import { styles } from "./styles";
import { ROLE_ADMIN } from "../App";

export const creditMode = [
  { id: "bank_transfer", name: "Bank Transfer" },
  { id: "credit_card", name: "Credit Card" },
  { id: "kredivo", name: "Kredivo" },
  { id: "gopay", name: "Go-PAY" },
  { id: "dana", name: "DANA" },
];

export const dummyBins = [
  { id: "bca", name: "BCA" },
  { id: "mega", name: "Bank MEGA" },
  { id: "citybank", name: "CityBank" }
];

export const paymentDefaultValue = {
  active: false,
  supported_methods: [],
  supported_bins: [],
  installment: false,
  error_message: ""
};
export const validatePayment = values => {
  const errors = {};
  if (!values.name) {
    errors.name = ["Name is required"];
  } else if (values.name.trim().length <= 0) {
    errors.name = ["Name is required"];
  }
  return errors;
};

export const PaymentFilter = ({ ...props }) => (
  <Filter {...props}>
    {permissions => [
      <TextInput label="resources.actions.search" source="search" alwaysOn />
    ]}
  </Filter>
);

export const PaymentActions = ({
  resource,
  filters,
  displayedFilters,
  filterValues,
  basePath,
  showFilter,
  refresh
}) => (
  <CardActions style={styles.cardActionStyleSmall} className="detail-actions">
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button"
      })}
    <WithPermission value={ROLE_ADMIN}>
      <CreateButton basePath={basePath} />
    </WithPermission>
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/paymentmode/defaultValues.js